import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef } from "react";
function Card({
  title,
  description,
  onClick
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "tw:max-w-72 tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:shadow-sm tw:p-4 hover:tw:shadow-lg hover:tw:border-gray-300 tw:transition-all tw:duration-200 tw:cursor-pointer tw:text-left",
      onClick,
      children: /* @__PURE__ */ jsxs("div", { className: "tw:space-y-2", children: [
        /* @__PURE__ */ jsx("h4", { className: "tw:text-sm tw:font-semibold tw:text-gray-900 tw:leading-tight", children: title }),
        /* @__PURE__ */ jsx("p", { className: "tw:text-sm tw:text-gray-600 tw:leading-relaxed", children: description })
      ] })
    }
  );
}
const AnimatedMasonryGrid = ({
  items,
  onItemClick
}) => {
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);
  const rows = [
    items.filter((_, i) => i % 3 === 0),
    items.filter((_, i) => i % 3 === 1),
    items.filter((_, i) => i % 3 === 2)
  ];
  const duplicatedRows = rows.map((row) => [...row, ...row]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      style: {
        width: "100%",
        overflow: "hidden",
        position: "relative",
        maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
        WebkitMaskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)"
      },
      onMouseEnter: () => setIsPaused(true),
      onMouseLeave: () => setIsPaused(false),
      children: [
        /* @__PURE__ */ jsx("style", { children: `
          @keyframes scroll-left {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes scroll-right {
            0% {
              transform: translateX(-50%);
            }
            100% {
              transform: translateX(0);
            }
          }

          .animate-scroll-left {
            animation: scroll-left 40s linear infinite;
          }

          .animate-scroll-right {
            animation: scroll-right 45s linear infinite;
          }

          .paused {
            animation-play-state: paused !important;
          }
        ` }),
        /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column", gap: "12px" }, children: duplicatedRows.map((row, rowIndex) => /* @__PURE__ */ jsx(
          "div",
          {
            className: `${rowIndex % 2 === 0 ? "animate-scroll-left" : "animate-scroll-right"} ${isPaused ? "paused" : ""}`,
            style: {
              display: "flex",
              gap: "8px",
              width: "max-content"
            },
            children: row.map((item, itemIndex) => /* @__PURE__ */ jsx(
              Card,
              {
                title: "Suggested search",
                description: item,
                onClick: () => onItemClick(item)
              },
              `${rowIndex}-${itemIndex}`
            ))
          },
          rowIndex
        )) })
      ]
    }
  );
};
export {
  AnimatedMasonryGrid
};
//# sourceMappingURL=AnimatedMasonryGrid.js.map
